const CHECKOUT_SELECTION_COMPONENT_SELECTOR = '[data-react-component="CheckoutProjectLicenseConfigurator"]';

export function checkoutSelectionPagePresent(root = document) {
  if (!root || typeof root.querySelector !== 'function') {
    return false;
  }

  return Boolean(root.querySelector(CHECKOUT_SELECTION_COMPONENT_SELECTOR));
}

export function shouldRefreshForHistoryNavigation(event) {
  if (typeof window === 'undefined') {
    return false;
  }

  if (event?.persisted) {
    return true;
  }

  if (typeof window.performance?.getEntriesByType === 'function') {
    const navigationEntries = window.performance.getEntriesByType('navigation');
    if (Array.isArray(navigationEntries) && navigationEntries[0]?.type === 'back_forward') {
      return true;
    }
  }

  if (window.performance?.navigation) {
    return window.performance.navigation.type === 2;
  }

  return false;
}

export function refreshCheckoutSelectionPage(root = document, reload = () => window.location.reload()) {
  if (typeof window === 'undefined' || !checkoutSelectionPagePresent(root)) {
    return false;
  }

  reload();
  return true;
}

export function initCheckoutSelectionHistoryRefreshGuard(root = document, options = {}) {
  if (typeof window === 'undefined' || !checkoutSelectionPagePresent(root) || root.body?.dataset?.checkoutSelectionHistoryRefreshGuardInitialized === 'true') {
    return null;
  }

  const handlePageShow = (event) => {
    if (!shouldRefreshForHistoryNavigation(event)) {
      return;
    }

    refreshCheckoutSelectionPage(root, options.reload);
  };

  window.addEventListener('pageshow', handlePageShow);
  if (root.body?.dataset) {
    root.body.dataset.checkoutSelectionHistoryRefreshGuardInitialized = 'true';
  }

  return () => {
    window.removeEventListener('pageshow', handlePageShow);
    if (root.body?.dataset) {
      delete root.body.dataset.checkoutSelectionHistoryRefreshGuardInitialized;
    }
  };
}

if (typeof document !== 'undefined') {
  const initialize = () => {
    initCheckoutSelectionHistoryRefreshGuard(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}
